import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Card, CardBody, CardTitle, Table, Button } from 'reactstrap';
import Switch from 'rc-switch';
import { Colxx, Separator } from 'Components/CustomBootstrap';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import { NotificationManager } from 'Components/ReactNotifications';
import LoadingOverlay from 'Components/LoadingOverlay';
import IntlMessages from 'Util/IntlMessages';
import {
	configsFindAllByGroup,
	configsBatchSetConfig,
	errorReset,
} from 'Redux/actions';
import * as configsReducer from 'Redux/configs/reducer';
import 'rc-switch/assets/index.css';

class PageConfigPasswordRules extends PureComponent {
	constructor() {
		super();
		this.breadcrumb = [
			{ id: 'menu.config' },
			{ id: 'menu.config.password-rules', href: '/config/password-rules' },
		];
		this.state = {
			complexPassword: false,
			passwordExpiry: false,
			preventPasswordReuse: false,
			failedLoginDisable: false,
		};
		this.onToggleSwitchComplexPasswordHandler = this.onToggleSwitchHandler.bind(this, 'complexPassword');
		this.onToggleSwitchPasswordExpiryHandler = this.onToggleSwitchHandler.bind(this, 'passwordExpiry');
		this.onToggleSwitchPreventPasswordReuseHandler = this.onToggleSwitchHandler.bind(this, 'preventPasswordReuse');
		this.onToggleSwitchFailedLoginDisableHandler = this.onToggleSwitchHandler.bind(this, 'failedLoginDisable');
		this.onSaveHandler = this.onSaveHandler.bind(this);
	}

	componentDidMount() {
		this.props.configsFindAllByGroup('user');
		this.props.errorReset('configs');
	}

	componentDidUpdate(prevProps) {
		const prevConfigs = prevProps.configs.get('user');
		const configs = this.props.configs.get('user');
		if (configs && configs !== prevConfigs) {
			let newState = {};
			configs.forEach((config) => {
				switch (config.name) {
				case 'user_complex_password':
					newState.complexPassword = config.value === '1';
					break;
				case 'user_password_expiry':
					newState.passwordExpiry = config.value === '1';
					break;
				case 'user_prevent_password_reuse':
					newState.preventPasswordReuse = config.value === '1';
					break;
				case 'user_failed_login_disable':
					newState.failedLoginDisable = config.value === '1';
					break;
				}
			});
			this.setState(newState);
		}

		const prevStatus = prevProps.status.get('configs');
		const status = this.props.status.get('configs');
		if (status && prevStatus !== status) {
			switch (status) {
			case 'submitted':
				NotificationManager.success(
					'The password rules are updated successfully.',
					'Config Updated'
				);
				break;
			case 'has-errors':
				NotificationManager.error(
					'Error occured! The password rules are NOT updated.',
					'Config Update Failed'
				);
				break;
			}
		}
	}

	onToggleSwitchHandler(id) {
		const value = this.state[id];
		let newState = {};
		newState[id] = !value;
		this.setState(newState);
	}

	onSaveHandler() {
		const { complexPassword, passwordExpiry, preventPasswordReuse, failedLoginDisable } = this.state;
		const data = {
			group: 'user',
			items: [
				{ name: 'user_complex_password', value: complexPassword ? '1' : '0' },
				{ name: 'user_password_expiry', value: passwordExpiry ? '1' : '0' },
				{ name: 'user_prevent_password_reuse', value: preventPasswordReuse ? '1' : '0' },
				{ name: 'user_failed_login_disable', value: failedLoginDisable ? '1' : '0' },
			],
		};
		this.props.configsBatchSetConfig(data);
	}

	render() {
		const status = this.props.status.get('configs');
		const { complexPassword, passwordExpiry, preventPasswordReuse, failedLoginDisable } = this.state;
		const isLoading = status === 'fetching' || status === 'submitting';
		return (
			<Fragment>
				<Row>
					<Colxx xxs="12">
						<BreadcrumbContainer
							heading={ <IntlMessages id="config.password-rules.heading" /> }
							items={ this.breadcrumb }
							match={ this.props.match }
						/>
					</Colxx>
				</Row>

				<Separator className="mb-5" />

				<Row>
					<Colxx xxs="12">
						<Card className="mb-4">
							<LoadingOverlay active={ isLoading }>
								<CardBody>
									<CardTitle>
										<IntlMessages id="config.password-rules.password-rule-security" />
									</CardTitle>
									<Table>
										<thead>
											<tr>
												<th width="80%">Rule</th>
												<th width="20%">Status</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<th>
													<h5>Complex Password</h5>
													<span>Length 10, complexity: upper lower case + symbol + number</span>
												</th>
												<td>
													<Switch
														className="custom-switch custom-switch-primary"
														checked={ complexPassword }
														onChange={ this.onToggleSwitchComplexPasswordHandler }
													/>
												</td>
											</tr>
											<tr>
												<th>
													<h5>Password Expiry</h5>
													<span>90 days valid only. Force to change password on 91st day. </span>
												</th>
												<td>
													<Switch
														className="custom-switch custom-switch-primary"
														checked={ passwordExpiry }
														onChange={ this.onToggleSwitchPasswordExpiryHandler }
													/>
												</td>
											</tr>
											<tr>
												<th>
													<h5>Prevent Password Re-Use</h5>
													<span>Cannot re-use the previous 5 passwords</span>
												</th>
												<td>
													<Switch
														className="custom-switch custom-switch-primary"
														checked={ preventPasswordReuse }
														onChange={ this.onToggleSwitchPreventPasswordReuseHandler }
													/>
												</td>
											</tr>
											<tr>
												<th>
													<h5>Disable Account</h5>
													<span>Disable account if user reaches 5 consecutive login failures</span>
												</th>
												<td>
													<Switch
														className="custom-switch custom-switch-primary"
														checked={ failedLoginDisable }
														onChange={ this.onToggleSwitchFailedLoginDisableHandler }
													/>
												</td>
											</tr>
										</tbody>
									</Table>

									<div className="mt-4 text-center">
										<Button size="lg" color="primary" onClick={ this.onSaveHandler } disabled={ isLoading }>
											SAVE
										</Button>
									</div>
								</CardBody>
							</LoadingOverlay>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

export default connect(
	configsReducer.selector,
	{
		configsFindAllByGroup,
		configsBatchSetConfig,
		errorReset,
	}
)(PageConfigPasswordRules);